import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState, useCallback} from "react";
import Form from "react-bootstrap/Form";
import moment from "moment";
// -
import DateTimesUtils from "core/utils/DateTimesUtils";
import {ReportProgrammingModel} from "./ReportProgrammingModel";
import axiApi from "ApiCaller";
import FiltersProgramming from "./FiltersProgramming";
import CreatableSearchSelect from "components/selects/CreatableSearchSelect";

const FormProgramming = ({
    item = {...ReportProgrammingModel},
    setItem,
    optionsShown,
    setOptionsShown,
    option,
    setOption,
    inputRefs,
}) => {
    const {t: _Tt} = useTranslation("tables");
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tc} = useTranslation("choices");
    const {t: _Td} = useTranslation("datestimes");
    const dates = useRef({
        start: null,
    });
    const [email, setEmail] = useState([]);
    const [filterOptions, setFilterOptions] = useState({
        groups: [],
        zones: [],
        routes: [],
        islands: [],
    });

    const handleFilterChange = useCallback(
        (filters) => {
            setItem((prevItem) => ({
                ...prevItem,
                filters: filters,
            }));
        },
        [setItem]
    );

    const getEmailRecipientsArray = (recipients) => {
        if (!recipients) return [];
        if (Array.isArray(recipients)) {
            if (
                recipients.length > 0 &&
                typeof recipients[0] === "object" &&
                recipients[0].value !== undefined
            ) {
                return recipients;
            }
            if (recipients.length > 0 && typeof recipients[0] === "string") {
                return recipients.map((email) => ({value: email, label: email}));
            }
            return recipients;
        }
        if (typeof recipients === "string") {
            return recipients
                .split("\n")
                .map((e) => e.trim())
                .filter((e) => e.length > 0)
                .map((email) => ({value: email, label: email}));
        }
        return [];
    };

    useEffect(() => {
        let item_ = {...item};
        if (item_.date_start) {
            dates.current.start = moment(item_.date_start, "YYYY-MM-DD");
            item_.date_start = dates.current.start.format("YYYY-MM-DD");
        } else {
            dates.current.start = moment();
            item_.date_start = dates.current.start.format("YYYY-MM-DD");
        }

        switch (item_.repeat) {
            case "w":
                break;
            case "m":
            case "y":
                calculateOptions(item_.repeat);
                switch (item_.values?.type) {
                    case "d":
                        setOption("0");
                        break;
                    case "n":
                        setOption("1");
                        break;
                    case "p":
                        setOption("2");
                        break;
                    default:
                }
                break;
            default:
        }

        item_.email_recipients = getEmailRecipientsArray(item_.email_recipients);

        if (item_.values && Object.keys(item_.values).length > 0) {
            item_.filters = {...item_.values};
        }

        setItem(item_);
    }, [item.id]);

    // console.log("ITEM", item);

    useEffect(() => {
        axiApi
            .get("/api/reports/programing/download/")
            .then((resp) => {
                if (resp.data) {
                    setFilterOptions({
                        groups: resp.data.groups || [],
                        zones: resp.data.zones || [],
                        routes: resp.data.routes || [],
                        islands: resp.data.islands || [],
                    });
                    setEmail(
                        resp.data.emails.map((email) => ({
                            value: email,
                            label: email,
                        })) || []
                    );
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }, []);
    // console.log("setEmail", email);

    const handleChange = (e) => {
        const {name, type} = e.target;
        let value = type === "checkbox" ? e.target.checked : e.target.value;
        let item_ = {...item};
        item_[name] = value;

        switch (name) {
            case "date_start":
                dates.current.start = moment(e.target.value, "YYYY-MM-DD");
                ["m", "y"].includes(item_.repeat) && calculateOptions(item_.repeat);
                break;

            case "repeat":
                calculateOptions(e.target.value);
                break;
            default:
        }
        setItem(item_);
    };

    const calculateOptions = (repeat) => {
        setOptionsShown([]);
        setOption("0");
        let options_ = [];
        let day, dayPlace, weekday, dayName;
        day = dates.current.start.format("D");
        switch (repeat) {
            case "m": // month
                options_.push({
                    id: "0",
                    day: day,
                    value: 0,
                    type: "d",
                    title: `El día ${day}`,
                });
                dayPlace = DateTimesUtils.dayMonthPlace(
                    dates.current.start.format("YYYY-MM-DD")
                );
                weekday = dates.current.start.format("d");
                dayName = _Td("days_name." + weekday);
                options_.push({
                    id: "1",
                    day: weekday,
                    value: dayPlace,
                    type: "n",
                    title: `${_Td("the_place." + dayPlace)} ${dayName.toLowerCase()}`,
                });
                if (dayPlace >= 4) {
                    options_.push({
                        id: "2",
                        day: weekday,
                        value: "last",
                        type: "p",
                        title: `${_Td("the_place.last")} ${dayName.toLowerCase()}`,
                    });
                }
                break;
            case "y": // years
                let month = dates.current.start.format("M");
                options_.push({
                    id: "0",
                    day: day,
                    value: month,
                    type: "d",
                    title: `El ${day} de ${_Td("months_name." + month)}`,
                });
                dayPlace = DateTimesUtils.dayMonthPlace(
                    dates.current.start.format("YYYY-MM-DD")
                );
                weekday = dates.current.start.format("d");
                dayName = _Td("days_name." + weekday);
                options_.push({
                    id: "1",
                    day: weekday,
                    value: month,
                    place: dayPlace,
                    type: "n",
                    title: `${_Td(
                        "the_place." + dayPlace
                    )} ${dayName.toLowerCase()} de ${_Td("months_name." + month)}`,
                });
                if (dayPlace >= 4) {
                    options_.push({
                        id: "2",
                        day: weekday,
                        value: month,
                        place: "last",
                        type: "p",
                        title: `${_Td(
                            "the_place.last"
                        )} ${dayName.toLowerCase()} de ${_Td("months_name." + month)}`,
                    });
                }
                break;
            default:
        }
        setOptionsShown(options_);
    };

    const handleOptions = (e) => {
        const {value} = e.target;
        setOption(value);
    };

    const getEmailRecipientsValue = () => {
        if (!item.email_recipients) return "";
        if (Array.isArray(item.email_recipients)) {
            // Check if it's array of objects (SearchSelect format) or strings
            if (
                item.email_recipients.length > 0 &&
                typeof item.email_recipients[0] === "object"
            ) {
                return item.email_recipients.map((obj) => obj.value).join("\n");
            }
            return item.email_recipients.join("\n");
        }
        return item.email_recipients;
    };

    const countEmails = () => {
        if (!item.email_recipients) return 0;
        if (Array.isArray(item.email_recipients)) {
            return item.email_recipients.length;
        }
        return item.email_recipients.split("\n").filter((e) => e.trim().length > 0)
            .length;
    };

    return (
        <div className="container-fluid">
            <div className="row g-3 mb-5 pb-5">
                <div className="col-12">
                    <div className="row g-3 align-items-center">
                        <div className="col-3">
                            <label htmlFor="name" className="col-form-label">
                                {_Tf("common.name")}*
                            </label>
                        </div>
                        <div className="col-7">
                            <input
                                type="text"
                                className="form-control"
                                id="name"
                                name="name"
                                value={item.name || ""}
                                onChange={handleChange}
                                required
                                ref={(el) => (inputRefs.current.name = el)}
                            />
                        </div>
                    </div>
                    <div className="row g-3 align-items-center mt-3">
                        <div className="col-3">
                            <label htmlFor="description" className="col-form-label">
                                {_Tf("common.description")}
                            </label>
                        </div>
                        <div className="col-7">
                            <textarea
                                className="form-control"
                                rows="4"
                                id="description"
                                name="description"
                                value={item.description || ""}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className="row g-3 align-items-center mt-3">
                        <div className="col-3">
                            <label htmlFor="date_start" className="col-form-label">
                                {_Tf("programming.start_date")}*
                            </label>
                        </div>
                        <div className="col-2">
                            <input
                                type="date"
                                className="form-control"
                                id="date_start"
                                name="date_start"
                                value={item.date_start || ""}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-1"></div>

                        <div className="col-2">
                            <label htmlFor="run" className="col-form-label">
                                {_Tt("common.start_hour")}*
                            </label>
                        </div>
                        {/* <div className="col-1"></div> */}
                        <div className="col-2">
                            <input
                                type="time"
                                className="form-control"
                                id="run"
                                name="run"
                                value={item.run || ""}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="row g-3 align-items-center mt-3">
                        <div className="col-3">
                            <label htmlFor="repeat" className="col-form-label">
                                {_Tt("common.repeat")} {_Tt("common.between")}*
                            </label>
                        </div>
                        <div className="col-2">
                            <Form.Select
                                id="repeat"
                                name="repeat"
                                value={item.repeat || "w"}
                                onChange={handleChange}
                                className="">
                                <option value="d">{_Tc("repeat.d")}</option>
                                <option value="w">{_Tc("repeat.w")}</option>
                                <option value="m">{_Tc("repeat.m")}</option>
                            </Form.Select>
                        </div>
                        <div className="col-1"></div>
                        <div className="col-2">
                            <label htmlFor="report_type" className="col-form-label">
                                {_Tt("programming.reportType")}*
                            </label>
                        </div>
                        <div className="col-3">
                            <Form.Select
                                id="report_type"
                                name="report_type"
                                value={item.report_type || "cp"}
                                onChange={handleChange}
                                className="">
                                <option value="cp">{_Tc("reports.cp")}</option>
                                <option value="ch">{_Tc("reports.ch")}</option>
                                <option value="pr">{_Tc("reports.pr")}</option>
                            </Form.Select>
                        </div>
                    </div>
                    {optionsShown.length > 0 ? (
                        optionsShown.map((_option, index) => (
                            <div className="row mt-3" key={index}>
                                <div className="col-3"></div>
                                <div className="col-9">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="options"
                                            id={_option.id}
                                            value={_option.id}
                                            checked={_option.id === option}
                                            onChange={handleOptions}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor={_option.id}>
                                            {_option.title}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <></>
                    )}
                </div>
                <div className="col-12 mt-5">
                    <hr className="mb-4" />
                    <FiltersProgramming
                        reportType={item.report_type}
                        filterOptions={filterOptions}
                        initialFilters={item.filters || {}}
                        onFilterChange={handleFilterChange}
                    />
                </div>

                <div className="col-12 mt-5">
                    <hr className="mb-4" />
                    <div className="row g-3 align-items-center">
                        <div className="col-3">
                            <label
                                htmlFor="email_recipients"
                                className="col-form-label">
                                {_Tt("common.destination_email")}*
                            </label>
                        </div>
                        <div className="col-9">
                            <CreatableSearchSelect
                                options={email}
                                value={getEmailRecipientsArray(item.email_recipients)}
                                onChange={(selectedOptions) => {
                                    let item_ = {...item};
                                    item_.email_recipients = selectedOptions || [];
                                    setItem(item_);
                                }}
                                placeholder="Ingresa emails..."
                                isMulti={true}
                                isClearable={true}
                                name="email_recipients"
                            />
                            <small className="text-muted mt-1 d-block">
                                {countEmails()} email(s) ingresado(s)
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default FormProgramming;
